export const TEMPLATE_FOLDER_REQUEST="TEMPLATE_FOLDER_REQUEST"
export const TEMPLATE_FOLDER_SUCCESS="TEMPLATE_FOLDER_SUCCESS"
export const TEMPLATE_FOLDER_FAIL="TEMPLATE_FOLDER_FAIL"